import { LitElement, html } from 'lit';

/**
 * Election Advertising Special Terms Content
 * Renders the full legal text for Election Advertising special terms.
 * Content matches the official PDF word-for-word.
 */
class ElectionSpecialTerms extends LitElement {
    createRenderRoot() {
        return this;
    }

    render() {
        return html`
            <div class="special-terms">
                <h4 class="text-base font-bold mb-4">ELECTION ADVERTISING - SPECIAL TERMS</h4>

                <p>
                    These Terms and Conditions ("T&Cs") govern the provision of letterbox
                    distribution, digital advertising, and design services ("Services") by REACH
                    ("We," "Us," or "Our") to the Client ("You" or "Your") for election campaign
                    marketing. By engaging Our Services, You agree to these T&Cs.
                </p>

                <h5>1. SCOPE OF SERVICES</h5>

                <p>
                    Our Services include campaign strategy, design, print production, letterbox
                    distribution, and digital advertising, as agreed in Your package. All services
                    are delivered based on the content, imagery, and specifications provided by You.
                </p>

                <h5>2. CLIENT RESPONSIBILITIES</h5>

                <p class="ml-6">
                    <strong>a. Content Accuracy & Legality:</strong> You are solely responsible for
                    the accuracy, legality, and truthfulness of all content (text, images, data,
                    etc.) provided. You warrant that all content complies with relevant electoral
                    laws, advertising standards, and does not infringe on third-party rights.
                </p>

                <p class="ml-6">
                    <strong>b. Approvals:</strong> You must review and approve all proofs (design,
                    print, digital) promptly. Your approval signifies acceptance. Errors or
                    omissions identified after final approval and production/distribution are Your
                    responsibility.
                </p>

                <p class="ml-6">
                    <strong>c. Compliance:</strong> You are responsible for ensuring all campaign
                    materials comply with local election laws, regulations, and any guidelines from
                    electoral authorities.
                </p>

                <p class="ml-6">
                    <strong>d. Third Party Policy Compliance:</strong> You are responsible for
                    ensuring all campaign materials comply with any policies, regulations, or
                    standards that are relevant to any publisher platforms, advertising networks, or
                    advertising tools that are to be used for your campaign. This includes, but is
                    not limited to; completing advertiser verification on relevant platforms, and
                    providing disclosure statements to these platforms.
                </p>

                <h5>3. DISCLAIMER OF ELECTION OUTCOME RESPONSIBILITY</h5>

                <p class="ml-6">
                    <strong>a. Service Provision Only:</strong> We provide marketing and design
                    services only. We are not responsible for campaign strategy, management, or
                    electoral consulting.
                </p>

                <p class="ml-6">
                    <strong>b. No Guarantee of Success:</strong> We do not guarantee any specific
                    election outcome, vote count, or campaign success. Many factors beyond our
                    control affect election results.
                </p>

                <p class="ml-6">
                    <strong>c. Independent Campaign Decisions:</strong> All campaign decisions,
                    including messaging, targeting, and distribution, are Your responsibility.
                </p>

                <h5>4. NO REFUNDS</h5>

                <p class="ml-6">
                    <strong>a. Service-Based Offering:</strong> Fees are for creative, production,
                    and distribution effort. Once work has commenced, fees are non-refundable.
                </p>

                <p class="ml-6">
                    <strong>b. Outcome Irrelevant to Refund:</strong> No refunds will be provided
                    due to campaign results, dissatisfaction with election outcomes, or campaign
                    changes.
                </p>

                <p class="ml-12">
                    - The Letterbox Services will be performed by REACH and its subcontractors using
                    reasonable endeavours. However, the Client (You) acknowledges and agrees that
                    the nature of the Letterbox Services and of REACH's distribution network means
                    that deliveries may vary in specific areas and that delivery to some homes or
                    businesses may not be completed. REACH does not warrant or represent that the
                    Letterbox Services will be completed in full, or that all Product will be
                    properly delivered.
                </p>

                <p class="ml-12">
                    - The pricing offered by REACH for Letterbox Services reflects these variables.
                    Where REACH becomes aware of missed or incomplete deliveries, it will use
                    reasonable endeavours to perform the Services using any available spare Product,
                    but it will not be liable to pay any compensation to the Client (You), or for
                    any production (or reproduction) or other costs relating to undelivered Product.
                </p>

                <p class="ml-6">
                    <strong>c. Cancellation Policy:</strong> If You cancel after work has commenced,
                    a cancellation fee applies based on work completed. If production/distribution
                    has occurred, 100% of fees are payable.
                </p>

                <h5>5. LIMITATION OF LIABILITY</h5>

                <p class="ml-6">
                    <strong>a.</strong> To the fullest extent permitted by law, REACH is not liable
                    for any indirect, incidental, special, reputational, consequential, or punitive
                    damages, or any loss of profits, revenues, data, goodwill, or other intangible
                    losses. Our total liability for any claim is limited to the amount paid by You
                    for the relevant service.
                </p>

                <p class="ml-6">
                    <strong>b.</strong> REACH is not liable for any indirect, incidental, special,
                    reputational, consequential, or punitive damages, or any loss of profits,
                    revenues, data, goodwill, or other intangible losses that may result from the
                    cancelation, removal, or restriction of advertising material by any third party,
                    including but not limited to; publisher platforms, advertising networks, or
                    advertising tools in use for this campaign.
                </p>

                <h5>6. INDEMNIFICATION</h5>

                <p>
                    You agree to indemnify and hold harmless REACH and its officers, directors,
                    employees, and agents from any claims, liabilities, damages, losses, costs, or
                    expenses (including legal fees) arising from Your breach of these T&Cs, Your
                    representations or warranties, or Your violation of any rights of another.
                </p>

                <h5>7. GOVERNING LAW</h5>

                <p>These T&Cs are governed by the laws of New Zealand.</p>

                <h5>8. ENTIRE AGREEMENT</h5>

                <p>
                    These T&Cs constitute the entire agreement between You and REACH regarding the
                    Services.
                </p>
            </div>
        `;
    }
}

customElements.define('election-special-terms', ElectionSpecialTerms);
